import React, { type ComponentProps } from 'react';
import { animated, type SpringValues, useTransition } from 'react-spring';
import { useDelayedHover } from '@mentimeter/react-hooks';
import { PortalOld } from '../portal';
import { Placement, type PlacementProps } from '../placement';

export interface TooltipGenericT extends PlacementProps {
  referenceId: string;
  delay?: number;
  portalPosition?: ComponentProps<typeof PortalOld>['position'];
  withPortal?: boolean;
  domId?: string;
}

/**
 * @deprecated Use the new accessible tooltip components instead. [Link to Storybook](https://storybook.mentimeter.org/?path=/docs/global-system-ragnar-ui-tooltip--docs)
 */
export const TooltipGeneric = ({
  referenceId,
  delay = 0,
  portalPosition,
  withPortal = true,
  domId = 'placement-portal',
  ...rest
}: TooltipGenericT) => {
  const isHovered = useDelayedHover(delay, referenceId);

  const transition = useTransition(isHovered, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  return (
    <>
      {transition(
        (styles, show) =>
          show &&
          (withPortal ? (
            <PortalOld position={portalPosition} domId={domId} zIndex={9999}>
              <animated.div
                aria-live="assertive"
                style={styles as SpringValues}
              >
                <Placement referenceId={referenceId} {...rest} />
              </animated.div>
            </PortalOld>
          ) : (
            <animated.div aria-live="assertive" style={styles as SpringValues}>
              <Placement referenceId={referenceId} {...rest} />
            </animated.div>
          )),
      )}
    </>
  );
};
